import { CommonModule }             from '@angular/common';
import { NgModule }                 from '@angular/core';
import {
	FormsModule,
	ReactiveFormsModule
}                                   from '@angular/forms';
import { DisableControlDirective }  from '@app/shared/directives/disable-control.directive';
import { FormControlTrimDirective } from '@app/shared/directives/form-control-trim.directive';
import { NgbTooltipModule }         from '@ng-bootstrap/ng-bootstrap';
import { ErrorModule }              from '@shared/form-elements/error/error.module';
import { InfoModule }               from '@shared/form-elements/info/info.module';
import { LabelModule }              from '@shared/form-elements/label/label.module';

@NgModule( {
	declarations: [
		DisableControlDirective,
		FormControlTrimDirective
	],
	imports: [],
	exports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		// Third Party
		NgbTooltipModule,

		// Shared
		DisableControlDirective,
		ErrorModule,
		FormControlTrimDirective,
		InfoModule,
		LabelModule
	]
} )
export class FormElementsModule {}
